import styled from "styled-components";

const BoldBlue = styled.span`
    font-size: 15px;
    color: blue;
    font-weight: 500;

    img {
        width: 10px;
        margin-right: 5px;
        margin-bottom: 2px;
    }
`;

export default BoldBlue;